import { useRouteError } from 'react-router-dom';
import { Footer } from './components/Footer';
import { AppNav } from './components/AppNav';
import { createLogger } from './utils/createLogger';

const logger = createLogger('ErrorPage');

export default function ErrorPage() {
  const error = useRouteError() as Error; // Specify Error as the type for the error variable

  // todo: report this to Sentry
  logger.error(error);

  return (
    <div className="flex min-h-screen flex-col items-center justify-between">
      <AppNav />
      <div
        className={`relative z-[2] mx-auto max-w-3xl justify-center p-12 text-center font-hand`}
      >
        <h1 className="mb-8 text-8xl">Oops!</h1>
        <p className="text-4xl">Sorry, an unexpected error has occurred.</p>
        {error.message && (
          <pre
            className={`text-md mt-4 overflow-auto rounded-md bg-slate-50 p-3 font-mono text-muted`}
          >
            {error.message}
          </pre>
        )}
      </div>
      <Footer />
    </div>
  );
}
